import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/theme.css';
import { watchInstall } from './install/pwa';
import { startUpdateWatch } from './update/watch';

const root = document.getElementById('root');
if (!root) {
  throw new Error('index.html must contain #root');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Registers the service worker on the web (the Android shell serves its own bundled assets)
// and keeps an eye out for newer builds on both.
startUpdateWatch();
watchInstall();
